import { useIntl } from "react-intl";
import { IconButton } from "src/design-system/components/IconButton/IconButton";
import type { ComponentProps } from "react";
import X from "src/design-system/icons/X.svg?react";
import color from "src/design-system/tokens/color";
import { iconSize } from "src/design-system/tokens/iconSize";
import messages from "./CloseButton.messages";

type CloseButtonProps = {
  onClick?: ComponentProps<typeof IconButton>["onPress"];
  size?: ComponentProps<typeof IconButton>["size"];
  color?: keyof typeof color;
  buttonRef?: React.Ref<HTMLButtonElement>;
  className?: string;
};

export function CloseButton(props: CloseButtonProps) {
  const intl = useIntl();

  return (
    <IconButton
      className={props.className}
      onPress={props.onClick}
      size={props.size ?? "sm"}
      variant="subtle"
      ref={props.buttonRef}
      aria-label={intl.formatMessage(messages.close)}
    >
      <X
        title={intl.formatMessage(messages.close)}
        color={props.color ?? color.icon.primary}
        width={iconSize[props.size ?? "md"]}
        height={iconSize[props.size ?? "md"]}
      />
    </IconButton>
  );
}
